import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "../css/Section8.module.css";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import sendEmail from "../../emailutil";
import sendEmailToOwner from "../../emailUtilOwner";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import marianaMain2 from "../../assets/mariana_pics/Main2.png";

const Section8 = () => {
  const language = useSelector((state: any) => state.language.value);

  const [name, setName] = useState("");
  const [instagramLink, setInstagramlink] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [country, setCountry] = useState("");
  const [telephone, setTelephone] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubject = (event: SelectChangeEvent) => {
    setSubject(event.target.value);
    console.log(name);
    console.log(instagramLink);
    console.log(dateOfBirth);
    console.log(country);
    console.log(telephone);
    console.log(email);
    console.log(subject);
    console.log(message);
  };

  const notify = (successful: boolean, message: string) => {
    toast(
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {message}
      </div>,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: successful ? "success" : "error",
      }
    );
  };

  useEffect(() => {
    if (window.location.hash === "#section8") {
      // Scroll to section 8
      const section8 = document.getElementById("section8");
      if (section8) {
        section8.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  const handleSendEmail = async () => {
    try {
      // Basic validation
      if (!name || !email || !telephone || !country || !subject || !message) {
        notify(
          false,
          language === "EN"
            ? "Please fill in all required fields (*)"
            : "Vă rugăm să completați toate câmpurile obligatorii (*)"
        );
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        notify(
          false,
          language === "EN"
            ? "Please enter a valid email address"
            : "Vă rugăm să introduceți o adresă de email validă"
        );
        return;
      }

      const emailData = {
        userEmail: email,
        itemName: "Consultation Request",
        subject: "New Consultation Request",
        message: `Name: ${name}<br>Email: ${email}<br>Date of Birth: ${dateOfBirth}<br>Telephone: ${telephone}<br>Country: ${country}<br>Instagram: ${instagramLink}<br>Phone: ${telephone}<br>Subject: ${subject} <br>Message: ${message}`,
        name: name,
        recepient: email,
      };

      const emailDataForUser = {
        userEmail: email,
        itemName: "Consultation Request",
        subject: "New Consultation Request",
        message: `You have booked a free consultation with Spirit Liber. We will contact you as soon as possible.`,
        name: name,
        recepient: email,
      };

      // Send both emails and wait for them to complete
      await Promise.all([
        sendEmail(emailDataForUser),
        sendEmailToOwner(emailData),
      ]);

      // If we get here, both emails were sent successfully
      notify(
        true,
        language === "EN"
          ? "Your consultation request has been sent successfully. We will contact you soon."
          : "Cererea dvs. de consultație a fost trimisă cu succes. Vă vom contacta în curând."
      );

      // Clear form fields after successful submission
      setName("");
      setInstagramlink("");
      setDateOfBirth("");
      setCountry("");
      setTelephone("");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error) {
      console.error("Email sending failed:", error);
      notify(
        false,
        language === "EN"
          ? "Failed to send request. Please try again later or contact us directly."
          : "Trimiterea cererii a eșuat. Vă rugăm să încercați din nou mai târziu sau să ne contactați direct."
      );
    }
  };

  return (
    <div className={styles.mainContainer}>
      <ToastContainer />

      <div className={styles.firstContainer}>
        <div className={styles.header}>
          <div className={styles.personalConsultation}>
            <span className={styles.personalConsultation1}>
              {language == "RO" && "Îți dorești o conversație cu"}
              {language == "EN" &&
                "Would you like to have a conversation with a "}
            </span>
            <span className={styles.consultation}>
              {language == "RO" && " Spirit liber?"}
              {language == "EN" && " Free Spirit?"}
            </span>
          </div>
        </div>
        <div className={styles.frameE}>
          <img src={marianaMain2} alt="book" />
        </div>
      </div>
      <div className={styles.lastContainer}>
        <div className={styles.contactUs}>
          <div className={styles.form}>
            <div className={styles.frame}>
              <div className={styles.frame3}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                      },
                  }}
                  hiddenLabel
                  id="filled-hidden-label-normal"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder={
                    language === "EN"
                      ? "Enter your name *"
                      : language === "RO"
                      ? "Introduceți numele dvs. *"
                      : ""
                  }
                  variant="filled"
                />
              </div>
              <div className={styles.frame3}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                      },
                  }}
                  value={instagramLink}
                  onChange={(e) => setInstagramlink(e.target.value)}
                  hiddenLabel
                  id="filled-hidden-label-normal"
                  placeholder={
                    language === "EN"
                      ? "Link to your Instagram"
                      : language === "RO"
                      ? "Link-ul Instagramului Dvs."
                      : ""
                  }
                  variant="filled"
                />
              </div>
            </div>
            <div className={styles.frame4}>
              <div className={styles.frame3}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                      },
                  }}
                  hiddenLabel
                  onChange={(e) => setDateOfBirth(e.target.value)}
                  value={dateOfBirth}
                  id="filled-hidden-label-normal"
                  placeholder={
                    language === "EN"
                      ? "Day / Month / Year of birth"
                      : language === "RO"
                      ? "Ziua / Luna / Anul nasterii"
                      : ""
                  }
                  variant="filled"
                />
              </div>
              <div className={styles.frame3}>
                <TextField
                  sx={{
                    width: "100%",

                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                      },
                    "& .MuiOutlinedInput-notchedOutline ": {
                      border: "0",
                    },
                  }}
                  hiddenLabel
                  onChange={(e) => setCountry(e.target.value)}
                  value={country}
                  id="filled-hidden-label-normal"
                  placeholder={
                    language === "EN"
                      ? "Country Of residence *"
                      : language === "RO"
                      ? "Țara de reședință *"
                      : ""
                  }
                  variant="filled"
                />
              </div>
            </div>
            <div className={styles.frame4}>
              <div className={styles.frame3}>
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                      },
                  }}
                  hiddenLabel
                  onChange={(e) => setTelephone(e.target.value)}
                  value={telephone}
                  id="filled-hidden-label-normal"
                  placeholder={
                    language === "EN"
                      ? "Phone *"
                      : language === "RO"
                      ? "Telefon *"
                      : ""
                  }
                  variant="filled"
                />
              </div>
              <div className={styles.frame3}>
                <TextField
                  sx={{
                    width: "100%",

                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                    "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                      {
                        content: "none",
                        display: "none",
                      },
                    "& .MuiOutlinedInput-notchedOutline ": {
                      border: "0",
                    },
                  }}
                  hiddenLabel
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  id="filled-hidden-label-normal"
                  placeholder={
                    language === "EN"
                      ? "E-mail *"
                      : language === "RO"
                      ? "E-mail *"
                      : ""
                  }
                  variant="filled"
                />
              </div>
            </div>
            <div className={styles.frameA}>
              <div className={styles.writingAbout}>
                <span className={styles.writingAboutB}>
                  <FormControl
                    sx={{ width: "100%", border: "none", borderRadius: "0" }}
                  >
                    <Select
                      sx={{
                        border: "none",
                        borderRadius: "0",
                        color: "#517059",
                        fontFamily: "Lora",
                        ".MuiSelect-select": {
                          color: "#517059",
                          fontFamily: "Lora",
                        },
                        "& .MuiSelect-icon": {
                          color: "#517059",
                        },
                        "& .MuiSelect-outlined": {
                          color: "#517059",
                        },
                        "& .MuiInputBase-input": {
                          color: "#517059",
                          fontFamily: "Lora",
                        },
                        "& .MuiSelect-select:not([multiple]) option": {
                          color: "#517059",
                          fontFamily: "Lora",
                        },
                        "& .MuiSelect-select em": {
                          color: "#517059",
                          fontStyle: "inherit",
                          fontFamily: "Lora",
                        },
                      }}
                      value={subject}
                      onChange={handleSubject}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <em
                              style={{
                                color: "#517059",
                                fontStyle: "inherit",
                                fontFamily: "Lora",
                              }}
                            >
                              {language === "EN"
                                ? "Choose Subject *"
                                : language === "RO"
                                ? "Alege tema *"
                                : ""}
                            </em>
                          );
                        }
                        return selected;
                      }}
                    >
                      <MenuItem
                        value={"tema 1"}
                        sx={{ color: "#517059", fontFamily: "Lora" }}
                      >
                        tema 1
                      </MenuItem>
                      <MenuItem
                        value={"tema 2"}
                        sx={{ color: "#517059", fontFamily: "Lora" }}
                      >
                        tema 2
                      </MenuItem>
                      <MenuItem
                        value={"tema 3"}
                        sx={{ color: "#517059", fontFamily: "Lora" }}
                      >
                        tema 3
                      </MenuItem>
                    </Select>
                  </FormControl>
                </span>
              </div>
            </div>
            <div className={styles.frameC}>
              <TextField
                sx={{
                  width: "100%",
                  height: "100%",
                  "& .MuiFilledInput-root": {
                    backgroundColor: "transparent",
                    height: "100%",
                    whiteSpace: "normal", // Allow the text to wrap normally
                    wordBreak: "break-word",
                  },
                  "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                    {
                      content: "none",
                      display: "none",
                    },
                  "& .MuiFilledInput-root::after": {
                    content: "none",
                    display: "none",
                  },
                  "& .MuiFilledInput-root::before": {
                    content: "none",
                    display: "none",
                  },
                }}
                hiddenLabel
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                id="filled-hidden-label-normal"
                placeholder={
                  language === "EN"
                    ? "Tell us what you would like to talk about or what questions are bothering you? *"
                    : language === "RO"
                    ? "Spune-ne despre ce ai vrea să vorbim sau ce întrebări te deranjează? *"
                    : ""
                }
                variant="filled"
              />
            </div>
          </div>
          <div className={styles.containerizeThis} onClick={handleSendEmail}>
            <button className={styles.button}>
              <span className={styles.addToCart}>
                {language === "EN"
                  ? "Send request"
                  : language === "RO"
                  ? "Trimite cerere"
                  : ""}
              </span>
            </button>
            <span className={styles.contactInfo}>
              {language === "EN"
                ? "* After filling out the form, I will contact you to confirm the time"
                : language === "RO"
                ? "* După completarea formularului, vă voi contacta pentru a confirma ora"
                : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section8;
